import { useNavigate, useParams } from "react-router-dom"
import "./css/ReadEmail.css"
import { useEffect, useState } from "react"
import api from "../config/backend"
import axios from "axios"
import { Buffer } from "buffer"
import { BsArrowLeftShort } from "react-icons/bs"
import { IoMdArrowDropdown } from "react-icons/io"
import { AiFillStar } from "react-icons/ai"
import { SpinnerCircular } from "spinners-react"

const ReadEmail = () => {
    const [sender, setSender] = useState(undefined)
    const [senderEmail, setSenderEmail] = useState(undefined)
    const [subject, setSubject] = useState(undefined)
    const [receivedDate, setReceivedDate] = useState(undefined)
    const [starred, setStarred] = useState(false)
    const [isImportant, setIsImportant] = useState(false)
    const [emailParts, setEmailParts] = useState([])
    const [loading, setLoading] = useState(false)

    const { id } = useParams()

    const navigate = useNavigate()

    const _crm__token = localStorage.getItem("_crm__token")

    const read = async () => {
        setLoading(true)
        const { data, status } = await axios.post(`${api}/Mailbox/read-email`, { token: _crm__token, identifier: id, read: true })
        
        if (data.success) {
            const email = data.email

            const headers = email.payload.headers
            const labels = email.labelIds
            
            setStarred(labels.includes("STARRED"))
            setIsImportant(labels.includes("IMPORTANT"))

            headers.forEach(item => {
                if (item.name === "Subject") {
                    setSubject(item.value)
                }
                else if (item.name === "From") {
                    let mailer = item.value.replace(/ <.+>/, "")

                    mailer = mailer.replace(/(^"|"$)/g, '')

                    setSender(mailer)

                    const mail = item.value.replace(/(.+ )(<.+>)/, "$2")

                    setSenderEmail(mail)
                }
                else if (item.name === "Date") {
                    setReceivedDate(item.value)
                }
            })

            let parts = email.payload.parts

            if (parts === undefined) {
                parts = [email.payload]
            }

            setEmailParts(
                parts.map(item => {
                    const copy = JSON.parse(JSON.stringify(item))

                    if (item.mimeType === "text/html" || item.mimeType === "text/plain") {
                        const buffer = Buffer.from(item.body.data, "base64")

                        const decoded = String(buffer)

                        copy.body.data = decoded
                    }

                    return copy
                })
            )
        }

        setLoading(false)
    }

    console.log({ emailParts })

    useEffect(() => {
        if (id) {
            read()
        }
    }, [id])

    const isText = emailParts && emailParts.some(item => item.mimeType === "text/html") === false
    
    if (loading) {
        return (
            <div className="_7lzc">
                <SpinnerCircular size="80" />
            </div>
        )
    }
    
    return (
        <div className="_5edq">
            <div className="beanbag-kiln">
                <div className="settings">
                    <BsArrowLeftShort onClick={() => navigate("/mailbox")} />
                </div>
                <div className="subject">
                    <span>{subject}</span>
                    {isImportant ? <span className="feeze-pies">Important</span> : undefined}
                </div>
                <div className="emeroids-pus">
                    <div className="profile">
                        <div className="circle">
                            {sender && sender[0]}
                        </div>
                        <div>
                            <div className="scillas-sly">
                                <span>{sender}</span>
                                <span>{senderEmail}</span>
                            </div>
                            <div className="trams-ayes">
                                <span>to me</span>
                                <IoMdArrowDropdown />
                            </div>
                        </div>
                    </div>
                    <div className="crackup-law">
                        <div className="date">{receivedDate && new Date(receivedDate).toDateString()}</div>
                        <div>
                            <AiFillStar className={starred ? "starred" : undefined} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="finger-war">
                {emailParts.map((item, index) => {
                    if (item.mimeType === "text/plain") {
                        return isText ? (
                            <div className="plaintext">
                                {item.body.data}
                            </div>
                        ) : undefined
                    }

                    return isText ? undefined : <div key={index} dangerouslySetInnerHTML={{__html: item.body.data}}></div>
                })}
            </div>
        </div>
    )
}

export default ReadEmail
